import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import DatePickerComponentWithTime from "../DatePickerComponentWithTime";
import DropDownAllStaffs from "../Dropdowns/DropDownAllStaffs";
import DropDownRoomsNumber from "../Dropdowns/DropdownRoomsNumber";
import DropDownSpecificStaff from "../Dropdowns/DropDownSpecificStaff";
import DropDownComponentSortedFixed from "../DropDownComponentSortedFixed";

function TreatmentInformation({
  roomNumber,
  handleRoomNumberChange,
  clientIdState,
  clientStatus,
  firstName,
  lastName,
  profilePicture,
  selectedTherapist,
  handleSelectedTherapistChange,
  assignedSupportWorker,
  handleAssignedSupportWorkerChange,
  therapistAppointmentDays,
  handleTherapistAppointmentDaysChange,
  therapistAppointmentTime,
  handleTherapistAppointmentTimeChange,
  supportWorkerAppointmentDays,
  handleSupportWorkerAppointmentDaysChange,
  supportWorkerAppointmentTime,
  handleSupportWorkerAppointmentTimeChange,
  stepsAppointmentDays,
  handleStepsAppointmentDaysChange,
  stepsAppointmentTime,
  handleStepsAppointmentTimeChange,
  generateTimeOptions,
  medicalAppointment,
  handleMedicalAppointmentChange,
  visaAppointment,
  handleVisaAppointmentChange,
  massageDay,
  handleMassageDayChange,
}) {
  return (
    <div className="general-information-column">
      <div className="general-information-card">
        <div className="general-information-heading">
          <span className="general-information-kicker">Care planning</span>
          <h2>Treatment Information</h2>
          <p>Room, care team and scheduled appointments</p>
        </div>
      <div className="general-information-grid general-information-grid-treatment">
        <DropDownRoomsNumber
          title="Room number"
          width="100px"
          value={roomNumber}
          onChange={handleRoomNumberChange}
          clientId={clientIdState}
          clientStatus={clientStatus}
          clientFirstName={firstName}
          clientLastName={lastName}
          profilePictureUrl={profilePicture}
        />

        <DropDownAllStaffs
          title="Assigned Therapist"
          value={selectedTherapist}
          width="auto"
          onChange={handleSelectedTherapistChange}
        />

        <DropDownSpecificStaff
          title="Assigned Support Staff"
          value={assignedSupportWorker}
          onChange={handleAssignedSupportWorkerChange}
          allowedRoles={["Support Staff", "Therapist", "Super Admin"]}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingTop: "20px",
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 150 }}>
            <InputLabel id="therapist-days-label">
              Therapist Appt Days
            </InputLabel>
            <Select
              labelId="therapist-days-label"
              label="Therapist Days"
              value={therapistAppointmentDays}
              onChange={(e) =>
                handleTherapistAppointmentDaysChange(e.target.value)
              }
            >
              <MenuItem value="MON/THUR">MON/THUR</MenuItem>
              <MenuItem value="TUE/FRI">TUE/FRI</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150 }}>
            <InputLabel id="therapist-time-label">
              Therapist Appt Time
            </InputLabel>
            <Select
              labelId="therapist-time-label"
              label="Therapist Time"
              value={therapistAppointmentTime}
              onChange={(e) =>
                handleTherapistAppointmentTimeChange(e.target.value)
              }
            >
              <MenuItem value="13:10">1:10 PM</MenuItem>
              <MenuItem value="14:10">2:10 PM</MenuItem>
              <MenuItem value="15:10">3:10 PM</MenuItem>
              <MenuItem value="16:10">4:10 PM</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            gap: 16,
            paddingTop: 16,
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <FormControl sx={{ m: 1, minWidth: 140 }}>
              <InputLabel id="sw-days-label">SW Appt Day</InputLabel>
              <Select
                labelId="sw-days-label"
                label="SW Appt Day"
                value={supportWorkerAppointmentDays}
                onChange={(e) =>
                  handleSupportWorkerAppointmentDaysChange(e.target.value)
                }
              >
                {[
                  "MONDAY",
                  "TUESDAY",
                  "WEDNESDAY",
                  "THURSDAY",
                  "FRIDAY",
                  "SATURDAY",
                  "SUNDAY",
                ].map((day) => (
                  <MenuItem key={day} value={day}>
                    {day}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ m: 1, minWidth: 140 }}>
              <InputLabel id="sw-time-label">SW Appt Time</InputLabel>
              <Select
                labelId="sw-time-label"
                label="SW Appt Time"
                value={supportWorkerAppointmentTime}
                onChange={(e) =>
                  handleSupportWorkerAppointmentTimeChange(e.target.value)
                }
              >
                {generateTimeOptions().map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            <FormControl sx={{ m: 1, minWidth: 140 }}>
              <InputLabel id="steps-days-label">12 Steps Day</InputLabel>
              <Select
                labelId="steps-days-label"
                label="12 Steps Day"
                value={stepsAppointmentDays}
                onChange={(e) => handleStepsAppointmentDaysChange(e.target.value)}
              >
                {[
                  "MONDAY",
                  "TUESDAY",
                  "WEDNESDAY",
                  "THURSDAY",
                  "FRIDAY",
                  "SATURDAY",
                  "SUNDAY",
                ].map((day) => (
                  <MenuItem key={day} value={day}>
                    {day}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ m: 1, minWidth: 140 }}>
              <InputLabel id="steps-time-label">12 Steps Time</InputLabel>
              <Select
                labelId="steps-time-label"
                label="12 Steps Time"
                value={stepsAppointmentTime}
                onChange={(e) => handleStepsAppointmentTimeChange(e.target.value)}
              >
                {generateTimeOptions().map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <DatePickerComponentWithTime
          title="Medical Appointment"
          width="150px"
          value={medicalAppointment}
          onChange={handleMedicalAppointmentChange}
        />

        <DatePickerComponentWithTime
          title="Visa Appointment"
          width="150px"
          value={visaAppointment}
          onChange={handleVisaAppointmentChange}
        />

        <DropDownComponentSortedFixed
          api="daysOfWeek"
          title="Massage day"
          value={massageDay}
          onChange={handleMassageDayChange}
        />
      </div>
      </div>
    </div>
  );
}

export default TreatmentInformation;
